<template>
    <PullContainer
        ref="pullContainerRef"
        :pullDownLoading="true"
        :pullDownLabel="true"
        @pullDownLoadingSuccess="pullDownLoadingSuccess"
    >
        <template #container>
            <div class="public_container dimission_manage_wrap" v-loading="loading">
                <div class="returnNavBar">
                    <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"> </ReturnNavBar>
                </div>
                <div class="top_search">
                    <van-search
                        v-model="searchForm.keyword"
                        placeholder="请输入查询内容"
                        @search="onSearch"
                        @clear="onSearch"
                    >
                        <template #right-icon>
                            <i class="iconfont icon-shaixuan" @click="handleClickAdvancedFilter"></i>
                        </template>
                    </van-search>
                </div>
                <div class="mobile_container">
                    <div class="no-empty-list" v-if="!tableData.length">
                        <img
                            src="https://download.hecoos.com/enlightv/2024-48/4e42cbd3ef1bb6ec5d6f0de2b536b48d.png"
                            alt=""
                        />
                        <p>暂无人员</p>
                    </div>
                    <ul v-infinite-scroll="onLoadList">
                        <li v-for="(item, index) in tableData" :key="index" @click="handleClickDetail(item)">
                            <div class="img_box">
                                <img :src="item.avatar || defaultImg" alt="" />
                            </div>
                            <div class="list_item_middle">
                                <p>
                                    <span class="ellipsis">{{ item.name }}</span>
                                    <span
                                        class="tag_status"
                                        :class="
                                            item.quit_status == 0
                                                ? 'tag_status0'
                                                : item.quit_status == 1
                                                ? 'tag_status1'
                                                : 'tag_status2'
                                        "
                                        >{{
                                            item.quit_status == 0
                                                ? "待离职"
                                                : item.quit_status == 1
                                                ? "已离职"
                                                : item.quit_status == 2
                                                ? "已取消"
                                                : ""
                                        }}</span
                                    >
                                </p>
                                <p class="ellipsis">{{ item.department_path || item.department || "--" }}</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>

                <van-popup
                    v-if="searchPopupShow"
                    v-model="searchPopupShow"
                    :close-on-click-overlay="false"
                    :style="{ height: '60%', background: '#F7F8FA' }"
                    position="bottom"
                    round
                    @click-overlay="searchPopupShow = false"
                >
                    <div class="search_popup_header">
                        <div class="arrow_left_icon">
                            <van-icon name="arrow-left" @click="handleClickReturn" />
                        </div>
                        <div class="title" v-text="searchPopupTitle"></div>
                        <div class="right_btn_wrap">
                            <span
                                v-if="conditionShowType === 'condition' && confirmBtnShow"
                                class="clear_btn"
                                @click="handleClickClearCondition"
                                >清空</span
                            >
                            <span
                                v-if="conditionShowType === 'field_value' && confirmBtnShow"
                                class="confirm_btn"
                                @click="handleClickConditionConfirm"
                                >确定</span
                            >
                        </div>
                    </div>
                    <div class="search_popup_content">
                        <div v-if="conditionShowType === 'condition'">
                            <ul class="condition_fields_list">
                                <van-cell
                                    v-for="(item, index) in advancedFilterList"
                                    :key="item.field_key"
                                    :title="item.field_name"
                                    is-link
                                    @click="handleClickSelectFieldValue(item, index)"
                                >
                                    <template #default>{{ item.field_value_text || "请选择" }}</template>
                                </van-cell>
                            </ul>
                        </div>
                        <div v-else class="condition_value_wrap">
                            <ul v-if="advancedFilterFields.condition_type === 'quit_status'" class="options_list">
                                <li
                                    v-for="item in dimissionStatusList"
                                    class="options_item"
                                    @click="handleClickOptionsConditionItem(item, dimissionStatusList, 'quit_status')"
                                >
                                    <span v-text="item.label"></span>
                                    <van-checkbox v-model="item.checked" shape="square"></van-checkbox>
                                </li>
                            </ul>
                            <ul v-else-if="advancedFilterFields.condition_type === 'quit_type'" class="options_list">
                                <li
                                    v-for="item in dimission_type_list"
                                    class="options_item"
                                    @click="handleClickOptionsConditionItem(item, dimission_type_list, 'quit_type')"
                                >
                                    <span v-text="item.type_value"></span>
                                    <van-checkbox v-model="item.checked" shape="square"></van-checkbox>
                                </li>
                            </ul>
                            <van-cascader
                                v-else-if="advancedFilterFields.condition_type === 'department'"
                                v-model="cascaderValue"
                                :closeable="false"
                                :field-names="cascaderFieldNames"
                                :options="departmentList"
                                active-color="#2990FF"
                                title=""
                                @change="handleClickDepartmentFinish"
                            >
                            </van-cascader>
                            <van-calendar
                                v-else-if="advancedFilterFields.condition_type === 'date'"
                                :allow-same-day="true"
                                :max-date="dateCalendarMax"
                                :min-date="dateCalendarMin"
                                :poppable="false"
                                :show-confirm="false"
                                :show-title="false"
                                color="#1990FF"
                                type="range"
                                @confirm="handleClickRangeCalendarConfirm"
                            >
                            </van-calendar>
                        </div>
                    </div>
                </van-popup>
            </div>
        </template>
    </PullContainer>
</template>

<script>
import { getQuitReason, GetDepartmentList, quitList, cancelQuit, confirmQuit } from "@/api";
import { mapState } from "vuex";
import { pagination } from "@/mixins";
import { formatDate } from "@/utils";
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";

export default {
    name: "DimissionManage",
    components: { PullContainer, ReturnNavBar, FooterTabbar },
    data() {
        return {
            loading: false,
            defaultImg: require("@/assets/images/default.jpg"),
            searchForm: {
                keyword: "",
            },
            tableData: [],
            tabBarList: [
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "MPersonnelIndex",
                    title: "首页",
                },
                {
                    icon: "icon-tianjiachengyuan",
                    activeIcon: "icon-tianjiachengyuan-xuanzhong",
                    routerName: "DepartmentPersonnel",
                    title: "人员组织",
                },
                {
                    icon: "icon-lizhi",
                    activeIcon: "icon-lizhi-xuanzhong",
                    routerName: "DimissionManage",
                    title: "离职管理",
                },
            ],
            tabBarActive: 2,
            systemFilterFields: [], // 高级筛选字段
            custom_filter: {}, // 高级筛选确认条件
            searchPopupShow: false,
            confirmBtnShow: true,
            conditionShowType: "condition",
            conditionIndex: 0,
            advancedFilterFields: {},
            cascaderFieldNames: {},
            cascaderValue: "",
            departmentList: [],
            dateCalendarMin: new Date("2015-01-01"),
            dateCalendarMax: new Date("2070-01-01"),
            advancedFilterList: [
                {
                    field_key: "department_id",
                    field_name: "部门",
                    p_field_key: "",
                    field_value: "",
                    field_value_text: "",
                    field_type: "department",
                    operator: "",
                    common: false,
                },
                {
                    field_key: "quit_status",
                    field_name: "离职状态",
                    p_field_key: "",
                    field_value: "",
                    field_value_text: "",
                    field_type: "quit_status",
                    operator: "",
                    common: false,
                },
                {
                    field_key: "date",
                    field_name: "离职日期",
                    p_field_key: "",
                    field_value: "",
                    field_value_text: "",
                    field_type: "date",
                    operator: "",
                    common: false,
                },
                {
                    field_key: "quit_type",
                    field_name: "离职类型",
                    p_field_key: "",
                    field_value: "",
                    field_value_text: "",
                    field_type: "quit_type",
                    operator: "",
                    common: false,
                },
            ],
            dimissionStatusList: [
                { label: "待离职", value: 0 },
                { label: "已离职", value: 1 },
                { label: "已取消", value: 2 },
            ],
            dimission_type_list: [],
        };
    },
    mixins: [pagination],
    computed: {
        searchPopupTitle() {
            switch (this.conditionShowType) {
                case "condition":
                    return "筛选";
                    break;
                case "field_value":
                    if (this.advancedFilterFields.condition_type === "date") {
                        return "选择日期";
                    } else if (this.advancedFilterFields.condition_type === "quit_status") {
                        return "离职状态";
                    } else if (this.advancedFilterFields.condition_type === "quit_type") {
                        return "离职类型";
                    } else if (this.advancedFilterFields.condition_type === "department") {
                        return "选择部门";
                    } else {
                        return "选择条件值";
                    }
                default:
                    return "";
            }
        },
    },
    created() {
        this.getQuitReason();
        this.getLocalStorageFunction();
    },
    methods: {
        // 读取缓存
        getLocalStorageFunction() {
            let localStorageData = localStorage.getItem("mobileDimissionManageFilterList");
            if (localStorageData) {
                localStorageData = JSON.parse(localStorageData);
                this.searchForm.keyword = localStorageData.keyword;
                this.advancedFilterList = localStorageData.advancedFilterList;
            }
            this.onPullRefreshList();
            localStorage.removeItem("mobileDimissionManageFilterList");
        },
        // 写入缓存
        setLocalStorageFunction() {
            const params = {
                keyword: this.searchForm.keyword,
                advancedFilterList: this.advancedFilterList,
            };
            localStorage.setItem("mobileDimissionManageFilterList", JSON.stringify(params));
        },
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true;
                this.onPullRefreshList();
            }
        },
        getQuitReason() {
            getQuitReason({}).then((res) => {
                if (res.code === 200) {
                    this.dimission_type_list = res.data;
                } else {
                    this.$toast(res.message);
                }
            });
        },
        // 查看员工档案详情
        handleClickDetail(item) {
            this.setLocalStorageFunction();
            this.$router.push({
                name: "MLeaveOfficeDetail",
                query: {
                    uid: item.uid,
                    id: item.id,
                },
            });
        },
        // 搜索
        onSearch() {
            this.onPullRefreshList();
        },
        handleClickReturn() {
            if (this.conditionShowType === "condition") {
                this.searchPopupShow = false;
            } else {
            }

            this.conditionShowType = "condition";
        },
        //点击选择选项类型条件
        handleClickOptionsConditionItem(item, list, field_type) {
            if (field_type == "quit_status") {
                list.forEach((listItem) => {
                    if (listItem.value === item.value) {
                        if (item.hasOwnProperty("checked")) {
                            item.checked = !item.checked;
                        } else {
                            this.$set(item, "checked", true);
                        }
                    } else {
                        this.$set(listItem, "checked", false);
                    }
                });
            } else if (field_type == "quit_type") {
                list.forEach((listItem) => {
                    if (listItem.type_id === item.type_id) {
                        if (item.hasOwnProperty("checked")) {
                            item.checked = !item.checked;
                        } else {
                            this.$set(item, "checked", true);
                        }
                    } else {
                        this.$set(listItem, "checked", false);
                    }
                });
            }
        },
        //选择部门类型条件
        handleClickDepartmentFinish(data) {
            this.advancedFilterList[this.conditionIndex].field_value = data.value;
            this.advancedFilterList[this.conditionIndex].field_value_text = data.selectedOptions
                .map((option) => option.relate_name)
                .join("/");
        },
        //日期区间确定事件
        handleClickRangeCalendarConfirm(range) {
            const [start, end] = range;
            let value = [formatDate(start, "date"), formatDate(end, "date")];
            this.advancedFilterList[this.conditionIndex].field_value = value;
            this.advancedFilterList[this.conditionIndex].field_value_text = value.join("～").replace(/-/g, "/");
            this.conditionShowType = "condition";
            this.confirmBtnShow = true;
            this.handleFilterConfirm();
        },
        //清空筛选条件
        handleClickClearCondition() {
            this.advancedFilterList.forEach((item) => {
                item.field_value = "";
                item.field_value_text = "";
            });
            this.dimissionStatusList.forEach((item) => {
                this.$set(item, "checked", false);
            });
            this.dimission_type_list.forEach((item) => {
                this.$set(item, "checked", false);
            });

            this.handleFilterConfirm();
        },
        //点击打开选择条件值
        handleClickSelectFieldValue(item, index) {
            this.advancedFilterFields = item;
            this.advancedFilterFields.condition_type = item.field_type;
            this.conditionIndex = index;
            this.conditionShowType = "field_value";
            if (this.advancedFilterFields.field_type === "department") {
                if (this.departmentList.length === 0) {
                    this.getDepartmentList();
                }
                this.cascaderFieldNames = {
                    text: "relate_name",
                    value: "relate_id",
                    children: "children",
                };
                this.confirmBtnShow = true;
            } else if (this.advancedFilterFields.field_type === "date") {
                this.confirmBtnShow = false;
            } else {
                this.confirmBtnShow = true;
            }
        },
        //条件值确定事件
        handleClickConditionConfirm() {
            if (this.advancedFilterFields.condition_type == "quit_status") {
                const item = this.dimissionStatusList.find((item) => item.checked);
                this.advancedFilterList[this.conditionIndex].field_value = item.value;
                this.advancedFilterList[this.conditionIndex].field_value_text = item.label;
            } else if (this.advancedFilterFields.condition_type == "quit_type") {
                const item = this.dimission_type_list.find((item) => item.checked);
                this.advancedFilterList[this.conditionIndex].field_value = item.type_id;
                this.advancedFilterList[this.conditionIndex].field_value_text = item.type_value;
            }
            this.conditionShowType = "condition";
            this.confirmBtnShow = true;
            this.handleFilterConfirm();
        },
        // 点击高级筛选
        handleClickAdvancedFilter() {
            this.searchPopupShow = true;
        },
        handleFilterConfirm() {
            this.onPullRefreshList();
        },
        getDepartmentList() {
            GetDepartmentList().then((res) => {
                if (res.code === 200) {
                    this.departmentList = res.data || [];
                } else {
                    this.$toast(res.message);
                }
            });
        },
        onPullRefreshList() {
            this.loading = true;
            this.pagination.pageNum = 1;
            this.tableData = [];
            this.getTableData();
        },
        onLoadList() {
            if (this.pagination.total == this.tableData.length) {
                return false;
            }
            if (this.loading == false) {
                this.getTableData();
            }
        },
        getTableData() {
            this.loading = true;
            let params = {
                keyword: this.searchForm.keyword,
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
            };
            this.advancedFilterList.forEach((item) => {
                if (item.field_value !== "") {
                    params[item.field_key] = item.field_value;
                }
            });
            quitList(params).then((res) => {
                if (res.code === 200) {
                    const { data, total } = res.data;
                    this.tableData = this.tableData.concat(data);
                    this.pagination.total = total;
                    this.pagination.pageNum++;
                    this.loading = false;
                    if (this.pullDownLoading) {
                        this.pullDownLoading = false;
                        this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                    }
                } else {
                    this.loading = false;
                    this.$toast({
                        message: res.message,
                        type: "fail",
                    });
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.top_search {
    padding: 6px 16px;
    background: rgba(255, 255, 255, 1);
    border-bottom: 1px solid rgba(247, 248, 250, 1);

    .van-search {
        padding: 0;
        border-radius: 6px;
        background-color: rgba(243, 243, 243, 1);
        overflow: hidden;

        .van-search__content {
            background-color: rgba(243, 243, 243, 1);

            ::v-deep {
                .van-icon-search {
                    color: rgba(51, 51, 51, 1);
                }
            }
        }
    }
}
.mobile_container {
    ul {
        li {
            padding: 0 16px;
            height: 68px;
            margin-bottom: 1px;
            background-color: rgba(255, 255, 255, 1);
            display: flex;
            align-items: center;
            gap: 8px;
            .img_box {
                width: 44px;
                height: 44px;
                border-radius: 50%;
                background-color: rgba(204, 204, 204, 1);
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    object-fit: cover;
                }
            }
            .list_item_middle {
                flex: 1;
                overflow: hidden;
                p:nth-child(1) {
                    font-size: 14px;
                    font-weight: 700;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                    margin-bottom: 2px;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }
                .tag_status {
                    flex-shrink: 0;
                    height: 18px;
                    padding: 0 4px;
                    border-radius: 5px;
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    &.tag_status2 {
                        background-color: rgba(153, 153, 153, 0.15);
                        color: rgba(153, 153, 153, 1);
                    }
                    &.tag_status1 {
                        background-color: rgba(90, 179, 51, 0.15);
                        color: rgba(90, 179, 51, 1);
                    }
                    &.tag_status0 {
                        background-color: rgba(228, 65, 68, 0.15);
                        color: rgba(228, 65, 68, 1);
                    }
                }
                p:nth-child(2) {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(102, 102, 102, 1);
                }
            }
            .list_item_right {
                height: 100%;
                padding-left: 16px;
                display: flex;
                align-items: center;

                ::v-deep {
                    .van-checkbox__icon {
                        font-size: 16px;

                        .van-icon {
                            border-color: rgba(217, 217, 217, 1);
                            border-radius: 4px;
                            background-color: rgba(255, 255, 255, 1);
                        }
                    }

                    .van-checkbox__icon--checked {
                        .van-icon {
                            border-color: rgba(41, 144, 255, 1);
                            background-color: rgba(41, 144, 255, 1);
                        }
                    }
                }
            }
        }
    }
}
.search_popup_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    line-height: 24px;

    .arrow_left_icon {
        width: 16px;
        height: 16px;
    }

    .van-icon-arrow-left {
        color: #666666;
        font-size: 16px;
    }

    .title {
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        color: #333333;
    }

    .right_btn_wrap {
        .clear_btn {
            color: #e44144;
            line-height: 24px;
            font-size: 16px;
        }

        .confirm_btn {
            color: #2990ff;
            line-height: 24px;
            font-size: 16px;
        }
    }
}

.search_popup_content {
    padding: 0 16px 12px;
    height: calc(100% - 48px);

    .condition_fields_list {
        height: 100%;
        overflow-y: auto;
        ::v-deep .van-cell {
            margin-bottom: 10px;
            .van-cell__title {
                flex: none;
            }
        }
    }

    .condition_value_wrap {
        width: 100%;
        height: 100%;

        .options_list {
            background: #ffffff;
            border-radius: 10px;
            overflow-y: auto;
            max-height: 100%;

            .options_item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 10px 16px;
                border-bottom: 1px solid #e8e8e8;

                &:active {
                    background-color: rgba(153, 153, 153, 0.04);
                }
            }
        }

        ::v-deep .el-input-number {
            width: 100%;

            .el-input__inner {
                text-align: left;
            }
        }

        ::v-deep .van-cascader {
            .van-cascader__header {
                display: none;
            }

            .van-cascader__option {
                background: #ffffff;
            }
        }
    }

    .condition_add_btn {
        color: #2990f0;
        border-radius: 10px;
        background: #ffffff;
        padding: 10px 0;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        margin-top: 10px;
    }
}
.no-empty-list {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    padding-top: 25%;
    align-items: center;
    background-color: rgba(247, 248, 250, 1);

    img {
        width: 165px;
    }

    & > p {
        margin: 14px 0;
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 0px;
        line-height: 17.38px;
        color: rgba(41, 144, 240, 1);
    }
}
</style>
